import React, { useEffect, useState } from "react";
import { fetchHijriDate } from "../../services/hijriService";

const DateTimes = ({ currentTime, prayerData, textColor, timingColor }) => {
  const [hijri, setHijri] = useState({ day: "...", month: "...", year: "..." });

  const currentDateStr = currentTime
    ? currentTime.format("DD-MM-YYYY")
    : null;

  useEffect(() => {
    if (!currentDateStr) return;

    let active = true;

    const getHijri = async () => {
      try {
        const lat = prayerData?.startTimes?.latitude;
        const long = prayerData?.startTimes?.longitude;

        const rawHijri = await fetchHijriDate(currentDateStr, lat, long);

        if (active && rawHijri) {
          const parts = rawHijri.split(" ");
          if (parts.length === 3) {
            setHijri({
              day: parts[0],
              month: parts[1],
              year: parts[2],
            });
          } else {
            setHijri({ day: "", month: rawHijri, year: "" });
          }
        }
      } catch (e) {}
    };

    getHijri();
    return () => {
      active = false;
    };
  }, [currentDateStr, prayerData]);

  if (!currentTime) return null;

  const timeString = currentTime.format("hh:mm:ss");
  const meridiem = currentTime.format("A");
  const dateString = currentTime.format("DD.MM.YYYY");
  const dayName = currentTime.format("dddd").toUpperCase();

  return (
    <div className="w-full overflow-hidden">
      <div className="w-full flex flex-col md:flex-row justify-between items-center mt-[3svh] px-[4svw] gap-[2svh]">

        {/* Hijri Date */}
        <div className="text-center">
          <div className="flex justify-center items-baseline gap-[1svh]">
            <div
              className="font-bold leading-none"
              style={{ fontSize: "12svh", color: timingColor }}
            >
              {hijri.day}
            </div>
            <div
              style={{ fontSize: "4svh", color: textColor }}
            >
              {hijri.year}
            </div>
          </div>
          <div
            className="mt-[1svh]"
            style={{ fontSize: "3.5svh", color: textColor }}
          >
            {hijri.month}
          </div>
        </div>

        {/* Live Clock */}
        <div className="flex items-baseline justify-center gap-[1.2svh]">
          <div
            className="font-bold font-digital leading-none text-center"
            style={{ fontSize: "18svh", color: timingColor }}
          >
            {timeString}
          </div>
          <div
            className="font-bold leading-none"
            style={{ fontSize: "3.5svh", color: timingColor }}
          >
            {meridiem}
          </div>
        </div>

        {/* Gregorian Date */}
        <div className="text-center md:text-right" style={{ color: textColor }}>
          <div
            className="font-bold leading-none"
            style={{ fontSize: "5svh" }}
          >
            {dateString}
          </div>
          <div
            className="leading-none"
            style={{ fontSize: "5svh" }}
          >
            {dayName}
          </div>
        </div>
      </div>

      {/* Divider */}
      <div
        className="mt-[2svh]"
        style={{ width: "100vw", marginLeft: "calc(-50vw + 50%)" }}
      >
        <hr
          className="border-t-[0.6svh]"
          style={{ borderColor: textColor }}
        />
      </div>
    </div>
  );
};

export default DateTimes;
